import {Component, EventEmitter, Inject, OnDestroy, OnInit} from "@angular/core";
import {User} from "../../../../core/models/user";
import {IntegrationInvite} from "../../../../core/models/integrationInvite";
import {Subject, Subscription} from "rxjs";
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {IntegrationDao} from "../../../../core/services/dao/integrationDao";

@Component({
  selector: 'app-ftp',
  templateUrl: './ftp.component.html',
  styleUrls: ['./ftp.component.scss']
})
export class FtpComponent implements OnInit, OnDestroy {
  int = {type: 'ftp'} as any;
  error = false;
  loading = true;
  existingIntegrations = [];
  creating = false;
  user: User;
  invites: IntegrationInvite[];
  description: string = '';
  showAccounts = false;
  integrationName;
  integrationType;
  noAccounts = false;
  isAdmin = false;
  emitter: EventEmitter<any>;
  locationToVerify: Subject<string> = new Subject<string>();
  preventSubmit = false;
  ftpValidationError = '';

  private subs: Array<Subscription> = [];


  constructor(
    public dialogRef: MatDialogRef<FtpComponent>,
    public integrationDao: IntegrationDao,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    this.existingIntegrations = this.data.existingIntegrations;
    this.user = this.data.user;
    this.isAdmin = this.user ? this.user.isAdmin : false;
    this.invites = this.data.invites;
    this.description = this.data.description;
    this.integrationName = this.data.name;
    this.integrationType = this.data.type;
    this.emitter = this.data.emitter;
    if (this.existingIntegrations.length === 0) {
      this.creating = true;
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onViewInvitesClick() {
    this.emitter.emit(this.integrationType);
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.int.brand = this.data.brand;
    this.loading = false;
  }

  addAnother(e) {
    this.creating = true;
  }

  toggleShowAccounts() {
    this.showAccounts = !this.showAccounts;
  }

  create(e) {
    this.loading = true;
    // let sub = this.integrationDao.createFtp(this.int).subscribe(
    //   res => {
    //     if (!res) {
    //       this.error = true;
    //       this.loading = false;
    //       this.dialogRef.close();
    //     } else {
    //       this.error = false;
    //       this.dialogRef.close(res);
    //     }
    //   },
    //   err => console.error(err)
    // );
    // this.subs.push(sub);
  }

  public locationBlurred(location: string) {
    this.locationToVerify.next(location); //add to subject string, verification handled through [ftpDuplicate] directive
  }
//TODO default the folder name to the name of the brand
  public locationKeyupHandler(location: string) {
    let reg1 = /[^\d\w!-_.*`()]|[@:,$=+?;&]/g;
    let reg2 = /\/\//g;

    if (location[0] === '/') {
      this.preventSubmit = true;
      this.ftpValidationError = 'Error: Your location cannot begin with "/"';
    } else if(location.endsWith('/')) {
      this.preventSubmit = true;
      this.ftpValidationError = 'Error: Your location cannot end with "/"';
    } else if (location.search(reg2) !== -1) {
      this.preventSubmit = true;
      this.ftpValidationError =
        'Error: Your location contains an invalid sequence at character: ' + (location.search(reg2) + 1);
    } else if (location.search(reg1) !== -1) {
      this.preventSubmit = false;
      this.ftpValidationError = 'Error: Your location contains invalid characters.';
    } else {
      this.preventSubmit = false;
      this.ftpValidationError = '';
    }
    this.locationToVerify.next(location); //add to subject string, verification handled through [ftpDuplicate] directive
  }
}